import React, { useEffect, useState } from "react";
import Popup from "reactjs-popup";
import "reactjs-popup/dist/index.css";
import axios from "axios";
import { questions as allQuestions } from "../questions";
import { ProgressBar } from "react-bootstrap";
import Confetti from "react-confetti";
import "bootstrap/dist/css/bootstrap.min.css";
import { Zoom } from "react-reveal";

const Quiz = () => {
  const initialQuizState = {
    currentQuestion: 0,
    selectedOptions: Array(5).fill(""),
    score: 0,
    showScore: false,
    popupOpen: false,
  };

  const [questions, setQuestions] = useState([]);
  const [quizState, setQuizState] = useState(initialQuizState);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
  });

  useEffect(() => {
    // Select a random subset of 5 questions from allQuestions
    const randomQuestions = allQuestions.sort(() => Math.random() - 0.5).slice(0, 5);
    setQuestions(randomQuestions);
    // Initialize selectedOptions array
    setQuizState(prevState => ({
      ...prevState,
      selectedOptions: Array(randomQuestions.length).fill(""),
    }));
  }, []);  

  const handleOptionChange = (event) => {
    const { currentQuestion } = quizState;
    const updatedOptions = [...quizState.selectedOptions];
    updatedOptions[currentQuestion] = event.target.value;
    setQuizState({ ...quizState, selectedOptions: updatedOptions });
  };

  const progress = ((quizState.currentQuestion + 1) / questions.length) * 100;

  const handleNext = () => {
    const nextQuestion = quizState.currentQuestion + 1;

    console.log("Next question:", nextQuestion);

    if (nextQuestion < questions.length) {
      console.log("Moving to the next question");
      setQuizState({ ...quizState, currentQuestion: nextQuestion });
    } else {
      console.log("Opening the popup");
      setQuizState({ ...quizState, popupOpen: true });
    }
  };

  const handlePrev = () => {
    const prevQuestion = quizState.currentQuestion - 1;
    setQuizState({ ...quizState, currentQuestion: prevQuestion });
  };

  const restartQuiz = () => {
    setQuizState(initialQuizState);
  };

  const calculateScore = () => {
    let score = 0;
    for (let i = 0; i < questions.length; i++) {
      if (quizState.selectedOptions[i] === questions[i].correctAnswer) {
        score++;
      }
    }
    return score;
  };

  const handleFormChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    if (e) {
      e.preventDefault();
    } else {
      // Handle the case when the event object is undefined or null
      console.error("Event object is undefined or null");
      return;
    }

    const updatedFormData = {
      ...formData,
      score: calculateScore(), // Assuming calculateScore() function calculates the total score
      role: 11,
    };

    try {
      // Make a POST request to your API endpoint

      const response = await axios.post(
        "https://api.positivemindcare.com/api/v1/user/",
        updatedFormData
      );

      // Check if the request was successful
      if (response.status === 200) {
        // Handle success (e.g., show a success message)
        console.log("Form submitted successfully:", response.data);

        // Close the popup
        setQuizState({ ...quizState, popupOpen: false, showScore: true });
      } else {
        // Handle error (e.g., show an error message)
        console.error("Failed to submit form:", response.statusText);
      }
    } catch (error) {
      // Handle error (e.g., show an error message)
      console.error("Error submitting form:", error.message);
    }
  };

  return (
    <div className="mt-6">
      {quizState.showScore ? (
        <>
          <div className="flex  justify-center mt-12   ">
            <Confetti
              width={window.innerWidth}
              height={window.innerHeight}
              recycle={false}
            />

            <figure className="rounded-2xl p-2  shadow-lg ring-1 ring-gray-900/5 sm:col-span-2 xl:col-start-2 xl:row-end-1 w-[600px] ">
              <h2 className="text-7xl text-sky-800 p-4">Your Score is!</h2>
              <p className="text-xl mt-12">
                {calculateScore()} out of {questions.length}
              </p>
              <p className="text-xl mt-12 italic font-thin">
                You have Earned {calculateScore()} coins
              </p>
              <button
                className="text-white text-xl bg-purple-500 p-2 rounded-xl mt-8"
                onClick={restartQuiz}
              >
                Start Again
              </button>
            </figure>
          </div>
        </>
      ) : (
        <>
          <Zoom>
            <div className="bg-white w-full max-w-3xl  mx-auto px-4 lg:px-6 py-3 pr-2 shadow-xl rounded-xl border-2 border-slate-200 ">
              <div>
                <h5 className="text-start">
                  {/* {questions[quizState.currentQuestion].question} */}
                  {questions.length > 0 &&
        questions[quizState.currentQuestion].question}
                </h5>
              </div>

              <div>
                <ul className="flex flex-col ">
                {questions.length > 0 && 
                  questions[quizState.currentQuestion].options.map(
                    (option, index) => (
                      <div key={index} className="mt-3 shadow-md rounded-full">
                        <label className="flex items-center space-x-2 border-2 border-slate-200  h-12 rounded-full  pl-4 text-md hover:bg-[#9b2b78] hover:text-white">
                          <input
                            type="radio"
                            value={option}
                            checked={
                              quizState.selectedOptions[
                                quizState.currentQuestion
                              ] === option
                            }
                            onChange={handleOptionChange}
                            className=""
                          />
                          <span>{option}</span>
                        </label>
                      </div>
                    )
                  )}
                </ul>
                <div className="mt-8 pl-8 pr-2 ">
                  <ProgressBar
                    variant="secondary"
                    now={progress}
                    label={`${progress.toFixed(0)}%`}
                  />
                </div>
              </div>
              <div className="flex justify-between">
                <button
                  onClick={handlePrev}
                  disabled={quizState.currentQuestion === 0}
                  className="m-8 pl-2 text-[18px] 
              text-[#f36c26]"
                >
                  Prev
                </button>
                <button
                  onClick={handleNext}
                  className="m-8 text-[18px] bg-[#2755a3] pr-6 pl-6 pt-2 pb-2 rounded-full text-white"
                >
                  {quizState.currentQuestion === questions.length - 1
                    ? "Finish"
                    : "Next"}
                </button>
              </div>
            </div>
          </Zoom>
        </>
      )}

      <Popup
        open={quizState.popupOpen}
        onClose={() => setQuizState({ ...quizState, popupOpen: false })}
        modal
        nested
      >
        <form onSubmit={handleSubmit} className="popup-form">
          <div className="fontpop p-10">
            <div className="flex justify-center">
              <h4 className="text-[#f36c26]">Quiz Completed!</h4>
            </div>
            <div className="flex justify-center ">
              <h6 className="sm:text-xl text-sm  text-italic font-thin">
                Enter Details to see your Result
              </h6>
            </div>
            <div className="flex flex-col ">
              <label htmlFor="name" className="mb-2 text-xl">
                Name
              </label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleFormChange}
                required
                placeholder="Enter Name"
                className="border-slate-200  border-2 mb-4 p-1 rounded-md focus:border-[#9b2b78] focus:outline-none focus:ring-0"
              />
            </div>
            <div className="flex flex-col">
              <label htmlFor="mobile" className="mb-2 text-xl">
                Mobile Number
              </label>
              <input
                type="tel"
                id="mobile"
                name="mobile"
                value={formData.mobile}
                onChange={handleFormChange}
                required
                placeholder="Enter Mobile Number"
                className="border-slate-200  border-2 mb-4 p-1 rounded-md focus:border-[#9b2b78] focus:outline-none focus:ring-0"
              />
            </div>
            <div className="flex flex-col">
              <label htmlFor="email" className="mb-2 text-xl">
                Email Id
              </label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleFormChange}
                required
                placeholder="Enter Email Id"
                className="border-slate-200  border-2 p-1 rounded-md focus:border-[#9b2b78] focus:outline-none focus:ring-0"
              />

              <div className="flex justify-center mt-4 ">
                <button
                  onClick={() => handleSubmit()}
                  className="bg-[#105bab] p-2 text-white rounded-md "
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        </form>
      </Popup>
    </div>
  );
};

export default Quiz;
